import { render, staticRenderFns } from "./ForumThreadPageAsideThemes.vue?vue&type=template&id=3310fdb4&scoped=true"
import script from "./ForumThreadPageAsideThemes.vue?vue&type=script&lang=js"
export * from "./ForumThreadPageAsideThemes.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadPageAsideThemes.vue?vue&type=style&index=0&id=3310fdb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3310fdb4",
  null
  
)

export default component.exports